var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"production_wrap"},[_vm._m(0),_c('News'),_c('CallMe'),_c('MobileCallme')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"production_img"},[_c('div',{staticClass:"img_desc"})])
}]

export { render, staticRenderFns }